import { AssigneeEnum, StatusTypes } from '@secca/shared/models/enums';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ServiceTypeBase } from '@secca/case/components/case-plans/case-plans/add-service-order/models/serviceTypeBase';
import { ServiceOrder } from '@secca/shared/models/service-order/service-order';
import { MedicalFlightAuthorizationServiceOrderExtension } from '@secca/shared/models/service-order/medical-flight-authorization-service-order-extension';

@Component({
    selector: 'app-medical-flight-authorization-left-side',
    templateUrl: './medical-flight-authorization-left-side.component.html',
    styleUrls: ['./medical-flight-authorization-left-side.component.scss'],
    standalone: false
})
export class MedicalFlightAuthorizationLeftSideComponent extends ServiceTypeBase implements OnInit, OnChanges {
  disableEditingDescription = false;  
  _medicalFlightAuthorization: MedicalFlightAuthorizationServiceOrderExtension;

  @Input()
  set medicalFlightAuthorization(medicalFlightAuthorization: MedicalFlightAuthorizationServiceOrderExtension) {
    this._medicalFlightAuthorization = medicalFlightAuthorization;
    this.isValid();
  }

  get medicalFlightAuthorization() {
    return this._medicalFlightAuthorization;
  }

  @Input() caseId: number;
  @Input() serviceOrder: ServiceOrder;
  @Input() assignee: AssigneeEnum;

  isDescriptionValid: boolean;
  isCancelAllowed = true;

  constructor() {
    super();
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  ngOnInit() {
  }

  isValid(): boolean {
    this.serviceOrderTypeState.isLeftSideValid = true;
    return true;
  }

  changeStatus(val: StatusTypes, event: any = null) {
    if (val === this.serviceOrder.status && event != null) {
      return false;
    }
    if (val !== this.serviceOrder.status) {
      this.serviceOrder.status = val;
    }
  }

  expectedDisabled() {
    return true;
  }

  cancelledDisabled() {
    return !(this.isCancelAllowed && (this.serviceOrder.status === StatusTypes.COMMITTED));
  }

  committedDisabled() {
    return this.serviceOrder.status !== StatusTypes.CANCELLED;
  }

  dataChanged() {
    this.isValid();
  }

  get StatusTypes() {
    return StatusTypes;
  }

}
